import { Grid, Typography } from "@mui/material"
import React from "react"
import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"
import { PrimaryButton } from "../Button/Button"
import apace1 from "../../assets/new_images/apace_1.png"
import apace2 from "../../assets/new_images/apace_2.png"
import apace3 from "../../assets/new_images/apace_3.png"
import "./ApaceFamily.css"

const ApaceFamily = () => {
  const { ref, inView, entry } = useInView()
  return (
    <div className="apace_container custom_main_container">
      <motion.div
        className="apace_header"
        initial={inView === false ? { y: 30, opacity: 0 } : {}}
        animate={inView === true ? { y: 0, opacity: 1 } : {}}
        transition={{ bounce: false, type: "spring", stiffness: 30 }}
      >
        <Typography variant="h3">
          We’re always looking for passionate people.
          <br />
          <span> Join the apace family</span>.
        </Typography>
      </motion.div>
      <div className="apace_card_container">
        <Grid
          container
          spacing={4}
          className="Grid_container_spread_tablet"
          ref={ref}
        >
          <Grid item xs={12} md={4}>
            <motion.div
              className="apace_card"
              initial={inView === false ? { y: 30, opacity: 0 } : {}}
              animate={inView === true ? { y: 0, opacity: 1 } : {}}
              transition={{ bounce: false, type: "spring", stiffness: 30 }}
            >
              <img src={apace1} alt="apace" />
              <Typography variant="h4" className="apace_card_1">
                Diversity
              </Typography>
              <Typography variant="body1">
                The apace family is all about inclusion and diversity. We hire
                based on talent and no other reason. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt
                mollit anim id est laborum.
              </Typography>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={4}>
            <motion.div
              className="apace_card"
              initial={inView === false ? { y: 30, opacity: 0 } : {}}
              animate={inView === true ? { y: 0, opacity: 1 } : {}}
              transition={{ bounce: false, type: "spring", stiffness: 30 }}
            >
              <img src={apace2} alt="apace" />
              <Typography variant="h4" className="apace_card_2">
                No fine print
              </Typography>
              <Typography variant="body1">
                We are super transparent with employee benifits, we dont
                overpromise unless we can overdeliver. Excepteur sint occaecat
                cupidatat non proident, sunt in culpa qui officia deserunt
                mollit anim id est laborum.
              </Typography>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={4}>
            <motion.div
              className="apace_card"
              initial={inView === false ? { y: 30, opacity: 0 } : {}}
              animate={inView === true ? { y: 0, opacity: 1 } : {}}
              transition={{ bounce: false, type: "spring", stiffness: 30 }}
            >
              <img src={apace3} alt="apace" className="apace_card_3_img" />
              <Typography variant="h4" className="apace_card_3">
                Innovation
              </Typography>
              <Typography variant="body1">
                We never stop innovating. We reward out of the box thinking and
                will always be up for a challange. No gamble, no future is a
                motto we stand by. Excepteur sint occaecat cupidatat non
                proident, sunt in culpa qui officia.
              </Typography>
            </motion.div>
          </Grid>
        </Grid>
      </div>
      <div className="btn_container_apace">
        <PrimaryButton>FIND US ON ZIPERCRUITER</PrimaryButton>
      </div>
    </div>
  )
}

export default ApaceFamily
